import qs from 'qs';
import { client } from '@/client';

// 获取订阅列表-分页
export function getSubscriptionsPaginate(params) {
  return client.post(`/api/metrics/topic/subscription`, params);
}

// 获取订阅列表
export function getSubscriptions(params) {
  const { clusterName, ...others } = params;
  return client.get(`/api/metrics/topic/subscription/${clusterName}`, {
    ...others,
    isContainSystemTopic: true,
  });
}

// 获取所有namespace
export function getAllNamespaces(clusterName) {
  return client.get(`/api/console/security/getAllNamespaces`, { clusterName });
}

// 获取所有namespace-kop
export function getAllKopNamespaces(clusterName) {
  return client.get(`/api/console/kop/security/getAllNamespaces`, { clusterName });
}

// 获取Topics
export function getAllTopics(params) {
  return client.get(`/api/console/security/getAllTopics`, params);
}

// 获取订阅分区数据
export function getSubscriptionPartitionList(params) {
  const { clusterName, ...others } = params;
  return client.get(`/api/metrics/topic/partition/subscription/${clusterName}`, others);
}

// Subscription图表数据
export function getSubscriptionPartitionChartsData(params) {
  const { clusterName, ...others } = params;
  return client.get(`/api/monitor/topic/subscription/${clusterName}`, others);
}

// Subscription图表数据，非分区！
export function getSubscriptionChartsData(params) {
  const { clusterName, ...others } = params;
  return client.get(`/api/monitor/topic/partition/subscription/${clusterName}`, others);
}

// Subscription 分区图表数据
export function getPartitionSubscriptionChartsData(params) {
  const { clusterName, ...others } = params;
  return client.get(`/api/monitor/topic/partition/subscription/${clusterName}`, others);
}

// 重置偏移量
export function resetCursors(params) {
  return client.put('/api/resource/topic/subscription/reset-cursors', params);
}

// 清除积压
export function clearBacklog(params) {
  return client.delete('/api/resource/topic/clearBacklog', params);
}

// 订阅详情
export function getSubscriptionStats(params) {
  return client.get('/api/resource/topic/subscription/stats', params);
}

// 偏移量
export function getSubscriptionInternalStats(params) {
  return client.get('/api/resource/topic/subscription/internal-stats', params);
}

// 在线详情
export function getOnlineSubscriptionDetail(params) {
  const { clusterName, ...others } = params;
  return client.get(`/api/metrics/message/${clusterName}/onlineSubscriptionDetail`, others);
}

// 生产者
export function getProduceClients(params) {
  return client.post(`/api/metrics/message/produceClients`, params);
}

// 消费者
export function getConsumerClients(params) {
  return client.post(`/api/metrics/message/consumerClients`, params);
}

// token 校验
export function tokenVerification(params) {
  return client.get('/api/console/security/tokenVerification', params);
}

// 消息轨迹查询
export function getMessageTraceList(params) {
  return client.get('/api/message-trace/list', params);
}

// 消息轨迹详情
export function getMessageTraceDetail(params) {
  return client.get('/api/message-trace/detail', params);
}

// 消息轨迹消息详情
export function getMessageById(params) {
  const { clusterName, ...others } = params;
  return client.get(`/api/resource/message/${clusterName}/getMessageById`, others);
}

// 更新消息队列开关
export function updateMessageTraceOpen(params) {
  return client.post(`/api/message-trace/switch${qs.stringify(params, { addQueryPrefix: true })}`);
}
